import { RequestAction } from '@redux-requests/core';
import { AppsConstants } from 'modules/userApps/store/constants';
import { gql } from '@redux-requests/graphql';

export interface IHookLogsPagination {
  page: number;
  limit: number;
}

export const getAppHooksLogs = (appId: string, pagination: IHookLogsPagination): RequestAction => ({
  type: AppsConstants.APP_GET_HOOK_LOGS,
  request: {
    query: gql`
      query ($appId: ID!, $pagination: Pagination) {
        getAppHooksLogs(appId: $appId, pagination: $pagination) {
          id
          eventType
          eventName
          createdAt
          isSuccessful
          isFailed
        }
      }
    `,
    variables: { appId, pagination },
  },
  meta: {
    mutations: {
      [AppsConstants.APP + appId]: (app, { getAppHooksLogs }) => {
        if (!getAppHooksLogs || !getAppHooksLogs.length) {
          return { ...app, hasMoreLogs: false };
        } else {
          const { webHookLogs } = app;
          return {
            ...app,
            hasMoreLogs: true,
            webHookLogs: webHookLogs ? webHookLogs.concat(getAppHooksLogs) : getAppHooksLogs,
          };
        }
      },
    },
  },
});
